import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaUserPlus, FaFolderPlus } from 'react-icons/fa';
import '../styles/Dashboard.css';
import { useAuth } from '../context/AuthProvider';

const Dashboard = () => {
  const navigate = useNavigate();
  const { hasPermission, user } = useAuth();
  const [caseCount, setCaseCount] = useState(0);
  const [userCount, setUserCount] = useState(0);

  useEffect(() => {
    if (!user?.token) return;
    // Fetch cases
    fetch(`${process.env.REACT_APP_API_URL}/api/cases`, {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.data && Array.isArray(data.data.cases)) {
          setCaseCount(data.data.cases.length);
        } else {
          setCaseCount(0);
        }
      })
      .catch(() => setCaseCount(0));

    // Fetch users
    fetch(`${process.env.REACT_APP_API_URL}/api/users`, {
      headers: {
        'Authorization': `Bearer ${user.token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data && data.data && Array.isArray(data.data.users)) {
          setUserCount(data.data.users.length);
        } else {
          setUserCount(0);
        }
      })
      .catch(() => setUserCount(0));
  }, [user?.token]);

  return (
    <Layout>
      <div className="dashboard">
        <h1>Dashboard</h1>
        <div className="dashboard-content">
          <div className="dashboard-stats">
            {user?.role !== 'user' && (
              <div className={`stat-card ${user?.role === 'admin' ? 'col-md-12' : 'col-md-6'}`}>
                <h3>Total Users</h3>
                <p className="stat-number">{userCount}</p>
              </div>
            )}
            <div className={`stat-card ${user?.role === 'admin' ? 'col-md-12' : 'col-md-6'}`}>
              <h3>Total Cases</h3>
              <p className="stat-number">{caseCount}</p>
            </div>
          </div>
          
          <div className="dashboard-actions">
            {hasPermission('manage_users') && (
              <div className="action-card" onClick={() => navigate('/add-user')}>
                <div className="action-icon">
                  <FaUserPlus />
                </div>
                <div className="action-content">
                  <h3>Add New User</h3>
                  <p>Create a new user account</p>
                </div>
              </div>
            )}

            {hasPermission('add_cases') && (
              <div className="action-card" onClick={() => navigate('/add-case')}>
                <div className="action-icon">
                  <FaFolderPlus />
                </div>
                <div className="action-content">
                  <h3>Add New Case</h3>
                  <p>Create a new case file</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
